import dynamic from "next/dynamic";

export const ArticleFeed = dynamic(() => import("./ArticleFeed"));
export const Benefits = dynamic(() => import("./Benefits"));
export const BlockQuote = dynamic(() => import("./BlockQuote"));
export const Chatbot = dynamic(() => import("./Chatbot"));
export const CaseStudies = dynamic(() => import("./CaseStudies"));
export const CollapsibleSection = dynamic(() => import("./CollapsibleSection"));
export const CompanyBackground = dynamic(() => import("./CompanyBackground"));
export const Divider = dynamic(() => import("./Divider"));
export const Form = dynamic(() => import("./Form"));
export const HeaderSideImage = dynamic(() => import("./HeaderSideImage"));
export const HeaderTextOverlay = dynamic(() => import("./HeaderTextOverlay"));
export const InfoList = dynamic(() => import("./InfoList"));
export const LatestBlogs = dynamic(() => import("./LatestBlogs"));
export const LatestCareerAdvice = dynamic(() => import("./LatestCareerAdvice"));
export const LatestIndustryInsights = dynamic(() => import("./LatestIndustryInsights"));
export const LatestJobs = dynamic(() => import("./LatestJobs"));
export const LogoCarousel = dynamic(() => import("./LogoCarousel"));
export const MultiCards = dynamic(() => import("./MultiCards"));
export const NarrativePanel = dynamic(() => import("./NarrativePanel"));
export const PromotionalCarousel = dynamic(() => import("./PromotionalCarousel"));
export const PromoSection = dynamic(() => import("./PromoSection"));
export const RichText = dynamic(() => import("./RichText"));
export const SolutionsPanel = dynamic(() => import("./SolutionsPanel"));
export const StatCounterWidget = dynamic(() => import("./StatCounterWidget"));
export const TrendingButtons = dynamic(() => import("./TrendingButtons"));
export const FeatureTabsList = dynamic(() => import("./FeatureTabsList"));
export const JobsFeed = dynamic(() => import("./JobsFeed"));
export const BranchMap = dynamic(() => import("./BranchMap"));
export const BranchLookupPanel = dynamic(() => import("./BranchLookupPanel"));
export const ClientLocation = dynamic(() => import("./ClientLocation"));
export const ClientLocationLookupPanel = dynamic(() => import("./ClientLocationLookupPanel"));
export const FeaturedListImage = dynamic(() => import("./FeaturedListImage"));
export const EmployerPromoSection = dynamic(() => import("./EmployerPromoSection"));
export const AboutClientSection = dynamic(() => import("./AboutClientSection"));
export const AnchorToComponents = dynamic(() => import("./AnchorToComponents"));
export const QuickJobSearch = dynamic(() => import("./QuickJobSearch"));
export const JobsSearchFeed = dynamic(() => import("./JobsSearchFeed"));
export const JobsSearchFeedV2 = dynamic(() => import("./JobsSearchFeedV2"));
export const TileGrid = dynamic(() => import("./TileGrid"));
export const GridBox = dynamic(() => import("./GridBox"));
export const Spacer = dynamic(() => import("./Spacer"));
export const TheResults = dynamic(() => import("./TheResults"));
export const Faq = dynamic(() => import("./Faq"));
